import _ from "lodash";
import {getAppsPositionConfig} from "./getAppsPositionConfig";

export const getAppsPosition = (type, apps) => {
    const config = getAppsPositionConfig(type);

    let sorted = {};

    _.forEach(config, app => {
        if (_.has(apps, app)) {
            sorted = { ...sorted, [app]: apps[app] };
        }
    });

    _.forEach(apps, (app_name, app) => {
        if (!_.has(sorted, app)) {
            sorted = { ...sorted, [app]: apps[app] };
        }
    });

    return sorted;
};
